const STORAGE_KEY = 'wcag_font_level';
const LEVELS = {base: 1.00, large: 1.20, xlarge: 1.50}; // skale globalne
const ROOT_BASE_PERCENT = 100; // 100% przy base
const TOL = 0.6; // px – tolerancja różnic przy detekcji PX vs REM/EM

// Mapowanie Twoich klas na poziomy
const CLASS_TO_LEVEL = {
    'czcionka--a': 'base',
    'czcionka--aa': 'large',
    'czcionka--aaa': 'xlarge'
};

let currentLevel = (localStorage.getItem(STORAGE_KEY) || 'base');

const $root = document.documentElement;

$(document).ready(function (e)
{


    // ─────────── Stan ───────────


    // ─────────── Pomocnicze ───────────


    const mo = new MutationObserver((muts) => {
        const factor = LEVELS[currentLevel] || 1;
        for (const m of muts) {
            for (const node of m.addedNodes) {
                if (node.nodeType === 1) {
                    walk(node, (el) => rememberBase(el, factor));
                    walk(node, (el) => scalePxIfNeeded(el, factor));
                }
            }
        }
    });

    initControls();
    applyLevel(currentLevel);
    mo.observe(document.documentElement, {childList: true, subtree: true});
});

function setRootScale(level) {
    const factor = LEVELS[level] || 1;
    $root.style.fontSize = (ROOT_BASE_PERCENT * factor) + '%';
}

// zapamiętaj rozmiary bazowe (tj. „jakby przy base”)
function rememberBase(el, factor) {
    if (el.dataset.wcagNoscale !== undefined)
        return;

    const cs = getComputedStyle(el);

    // font-size bazowy w px
    if (!el.dataset.fzBase) {
        const fz = parseFloat(cs.fontSize) || 0;
        if (fz > 0)
            el.dataset.fzBase = (fz / factor).toFixed(4);
    }

    // line-height: zapisujemy tylko pikselowe
    if (!el.dataset.lhBase) {
        const lh = cs.lineHeight;
        if (lh && lh.endsWith('px')) {
            el.dataset.lhBase = (parseFloat(lh) / factor).toFixed(4);
        }
    }
}

// przeskaluj inline tylko wtedy, gdy element sam się NIE przeskalował (czyli był w PX)
function scalePxIfNeeded(el, factor) {
    if (el.dataset.wcagNoscale !== undefined)
        return;

    const cs = getComputedStyle(el);

    if (el.dataset.fzBase) {
        const base = parseFloat(el.dataset.fzBase);
        const expected = base * factor;
        const computed = parseFloat(cs.fontSize) || 0;

        if (Math.abs(computed - expected) > TOL) {
            el.style.setProperty('font-size', expected + 'px', 'important'); // PX „twardy”
        } else {
            el.style.removeProperty('font-size'); // REM/EM – nie nadpisujemy
        }
    }

    if (el.dataset.lhBase) {
        const base = parseFloat(el.dataset.lhBase);
        const expected = base * factor;
        const computed = parseFloat(cs.lineHeight) || 0;

        if (Math.abs(computed - expected) > TOL) {
            el.style.setProperty('line-height', expected + 'px', 'important');
        } else {
            el.style.removeProperty('line-height');
        }
    }
}

function walk(rootNode, fn) {
    fn(rootNode);
    const tw = document.createTreeWalker(rootNode, NodeFilter.SHOW_ELEMENT);
    let n;
    while (n = tw.nextNode())
        fn(n);
}

function applyLevel(level) {
    if (level === currentLevel)
        return;

    currentLevel = (level in LEVELS) ? level : 'base';
    localStorage.setItem(STORAGE_KEY, currentLevel);

    const factor = LEVELS[currentLevel];

    // 1) REM/EM: globalnie przez <html>
    setRootScale(currentLevel);

    // 2) PX: per-element
    walk(document.body, (el) => rememberBase(el, factor));
    walk(document.body, (el) => scalePxIfNeeded(el, factor));

    updatePressedStates();
}

// ─────────── UI (Twoje <p> w .czcionka) ───────────
function initControls() {
    const panels = document.querySelectorAll('.czcionka');
    panels.forEach(panel => {
        // dostępność dla <p> jako „przycisków”
        panel.querySelectorAll('.wcag--font').forEach(el => {
            if (!el.hasAttribute('role'))
                el.setAttribute('role', 'button');
            if (!el.hasAttribute('tabindex'))
                el.setAttribute('tabindex', '0');
        });

        // click
        panel.addEventListener('click', (e) => {
            const target = e.target.closest('.wcag--font');
            if (!target)
                return;

            const level = classToLevel(target.classList);
            if (!level || level === currentLevel)
                return;
            applyLevel(level);
        });

        // klawiatura (Enter/Space)
        panel.addEventListener('keydown', (e) => {
            if (e.key !== 'Enter' && e.key !== ' ')
                return;
            const target = e.target.closest('.wcag--font');
            if (!target)
                return;

            const level = classToLevel(target.classList);
            if (!level || level === currentLevel)
                return;
            e.preventDefault();
            applyLevel(level);
        });
    });

    updatePressedStates();
}

function classToLevel(classList) {
    for (const cls of classList) {
        if (CLASS_TO_LEVEL[cls])
            return CLASS_TO_LEVEL[cls];
    }
    return null;
}

function updatePressedStates() {
    const panels = document.querySelectorAll('.czcionka');
    panels.forEach(panel => {
        const items = panel.querySelectorAll('.wcag--font');
        items.forEach(el => {
            const level = classToLevel(el.classList);
            el.setAttribute('aria-pressed', String(level === currentLevel));
        });
    });
}